import { FC, Fragment, useEffect, useRef } from "react";
import "utils/styles/root.scss";
import "utils/styles/index.scss";
import "utils/styles/tailwind.css";
import 'suneditor/dist/css/suneditor.min.css';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigationType, Navigate, Outlet } from "react-router-dom";
import { AdminContainer } from "layouts/admin/layout";
import {
	PageAdminLogin, PageAdminHome, PageAdminConfig,
	PageAdminRoleCreate,
	PageAdminRoleUpdate,
	PageAdminRole,
	PageAdminRolePermissionManager,
	PageAdminUser,
	PageAdminUserCreate,
	PageAdminUserUpdate,
	PageAdminPermission,
	PageAdminPermissionCreate,
	PageAdminPermissionUpdate,
	PageAdminPermissionContainer,
	PageAdminUserPermissionManager,
	PageAdminProfile,
	PageAdminLibrary,
	PageAdminForm,
	PageAdminStatus,
	PageAdminStatusCreate,
	PageAdminStatusUpdate,
	PageAdminWorkflow,
	PageAdminWorkflowCreate,
	PageAdminWorkflowUpdate,

	PageAdminWorkflowStep,
	PageAdminWorkflowStepCreate,
	PageAdminWorkflowStepUpdate,
	PageAdminFormCreate,
	PageAdminFormUpdate,
	PageAdminFormField,
	PageAdminPage, PageAdminPageCreate, PageAdminPageUpdate, PageAdminPageBuilder,
	PageAdminTemplate,
	PageAdminTemplateCreate,
	PageAdminTemplateUpdate,
	PageAdminLayout,
	PageAdminLayoutUpdate,
	PageAdminLayoutCreate,
	PageAdminPageBuilderTest,
	PageAdminPageBuilderView,
	PageAdminData,
	PageAdminDataForm,
	PageAdminFormBuilder,
	PageAdminFormStatus,
	PageAdminGroupUser,
	PageAdminGroupUserCreate,
	PageAdminGroupUserUpdate,
	PageAdminGroupUserPermissionManager,
	PageAdminGroupUsers,
	PageAdminFormStep,
	PageAdminGroupFormAccessControll,
	PageAdminRoleFormAccessControll,
	PageAdminUserFormAccessControll,
	PageAdminFormStepConfig,
	PageAdminWorkflowStepProcessFlow,
	PageAdminPageBuilderView_V2,
} from "layouts";
import axios from "axios";
import { store } from "store";
import { authLogout } from "store/auth";
import { apiGetConfig, apiPagePublishPages } from "apis";
import { AppMessage, AppScroll } from "components";
import moment from "moment";
import { CONST_DAY_NAMES, CONST_DAY_NAMES_SHORT, CONST_MONTH_NAMES, CONST_MONTH_NAMES_SHORT } from "utils";
import NotFound from "layouts/view/component/NotFound";
import DataProvider from "layouts/admin/pages/data/Container";
import FilteredSearch from ".test/Search";
import TestNotify from ".test/notifi";
import useAppSelector from "hooks/useAppSelector";

moment.updateLocale("vi", {
	week: { dow: 1 },
	months: CONST_MONTH_NAMES,
	monthsShort: CONST_MONTH_NAMES_SHORT,
	weekdays: CONST_DAY_NAMES,
	weekdaysShort: CONST_DAY_NAMES_SHORT,
});

const AppContainer = () => {
	return <Fragment>

	</Fragment>
}

const App = () => {
	const tokenLocalStorge = localStorage.getItem("token");
	const e401 = useRef<boolean>(false);
	axios.defaults.headers["Content-Type"] = "application/json";
	axios.defaults.headers["Authorization"] = tokenLocalStorge ? `Bearer ${tokenLocalStorge}` : null;

	axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
	axios.interceptors.response.use(
		(response) => {
			return response;
		},
		async (error) => {
			console.log("error", error)
			let response = error.response || {};
			switch (error.response?.status) {
				case 401:
					if (!e401.current) {
						e401.current = true;
						setTimeout(() => {
							e401.current = false;
						}, 3000)
						AppMessage.error({
							title: "Thông báo!",
							message: "Phiên làm việc đã hết hạn. Vui lòng đăng nhập lại để tiếp tục!",
						});
					}
					store.dispatch(authLogout());
					break;
				case 403:
					AppMessage.error({
						title: "Thông báo!",
						message: "Bạn không có quyền thao tác. Vui lòng liên hệ quản trị viên!",
					});
					break;
				default:
					AppMessage.error({
						title: "Thông báo lỗi",
						message: response?.data?.message,
					});
					break;
			}
			return response;
		}
	);

	const scrollRef = useRef<HTMLDivElement>(null);
	useEffect(() => {
		apiGetConfig();
		apiPagePublishPages();
	}, [])

	const publishPages = useAppSelector(state => state.page.list.publishPages);

	return (
		<Fragment>
			<AppScroll className="h-screen w-screen" ref={scrollRef}>
				<Router>
					<ScrollRestoration scrollRef={scrollRef} />
					<Routes>
						{/* Test */}
						<Route path=".test" element={<Outlet />}>
							<Route path="search" element={<FilteredSearch />} />
							<Route path="notify" element={<TestNotify />} />
						</Route>
						{/* END Test */}
						<Route path="/administrator/login.html" element={<PageAdminLogin />} />
						<Route path="/administrator" element={<AdminContainer />}>
							<Route path="" element={<Navigate to="/administrator/dashboard.html" replace />} />
							<Route path="dashboard.html" element={<PageAdminHome />} />
							<Route path="profile.html" element={<PageAdminProfile />} />

							{/* folder-explorer */}
							<Route path="library.html" element={<PageAdminLibrary />} />

							<Route path="config.html" element={<PageAdminConfig />} />

							{/* Vai trò */}
							<Route path="role.html" element={<PageAdminRole />} />
							<Route path="role/create.html" element={<PageAdminRoleCreate />} />
							<Route path="role/update/:id.html" element={<PageAdminRoleUpdate />} />
							<Route path="role/access-control/:id.html" element={<PageAdminRolePermissionManager />} />
							<Route path="role/access-control/form/:roleId.html" element={<PageAdminRoleFormAccessControll />} />

							{/* Ngươi dùng */}
							<Route path="user.html" element={<PageAdminUser />} />
							<Route path="user/create.html" element={<PageAdminUserCreate />} />
							<Route path="user/update/:id.html" element={<PageAdminUserUpdate />} />
							<Route path="user/access-control/:id.html" element={<PageAdminUserPermissionManager />} />
							<Route path="user/access-control/form/:userId.html" element={<PageAdminUserFormAccessControll />} />


							{/* Nhóm người dùng */}
							<Route path="group-user.html" element={<PageAdminGroupUser />} />
							<Route path="group-user/create.html" element={<PageAdminGroupUserCreate />} />
							<Route path="group-user/update/:id.html" element={<PageAdminGroupUserUpdate />} />
							<Route path="group-user/access-control/:id.html" element={<PageAdminGroupUserPermissionManager />} />
							<Route path="group-user/users/:id.html" element={<PageAdminGroupUsers />} />
							<Route path="group-user/access-control/form/:groupId.html" element={<PageAdminGroupFormAccessControll />} />

							{/* Quyền */}
							<Route path="" element={<PageAdminPermissionContainer />}>
								<Route path="permission.html" element={<PageAdminPermission />} />
								{/* <Route element={<HeaderOutlet />} >
								</Route>
								<Route element={<ContentOutlet />} >
									<Route path="permission.html" element={<PageAdminPermission />} />
								</Route> */}
								{/* <Route path="permission.html" element={<PageAdminPermission />} /> */}
								<Route path="permission/create.html" element={<PageAdminPermissionCreate />} />
								<Route path="permission/update/:id.html" element={<PageAdminPermissionUpdate />} />
							</Route>

							{/* Trạng thái */}
							<Route path="status.html" element={<PageAdminStatus />} />
							<Route path="status/create.html" element={<PageAdminStatusCreate />} />
							<Route path="status/update/:id.html" element={<PageAdminStatusUpdate />} />

							{/* Quy trình */}
							<Route path="workflow.html" element={<PageAdminWorkflow />} />
							<Route path="workflow/create.html" element={<PageAdminWorkflowCreate />} />
							<Route path="workflow/update/:id.html" element={<PageAdminWorkflowUpdate />} />

							<Route path="workflow/process-flow/:workflowId.html" element={<PageAdminWorkflowStepProcessFlow />} />
							<Route path="workflow/step/:workflowId.html" element={<PageAdminWorkflowStep />} />
							<Route path="workflow/step/:workflowId/create.html" element={<PageAdminWorkflowStepCreate />} />
							<Route path="workflow/step/:workflowId/update/:id.html" element={<PageAdminWorkflowStepUpdate />} />

							{/* Form */}
							<Route path="form.html" element={<PageAdminForm />} />
							<Route path="form/create.html" element={<PageAdminFormCreate />} />
							<Route path="form/update/:id.html" element={<PageAdminFormUpdate />} />
							<Route path="form/field/:id.html" element={<PageAdminFormField />} />
							<Route path="form/builder/:id.html" element={<PageAdminFormBuilder />} />
							<Route path="form/:id/status.html" element={<PageAdminFormStatus />} />
							<Route path="form/:id/step.html" element={<PageAdminFormStep />} />
							<Route path="form/:formId/step/config/:stepId.html" element={<PageAdminFormStepConfig />} />


							<Route path="data" element={<DataProvider />}>
								<Route path=":formCode.html" element={<PageAdminData />} />
								<Route path=":formCode/:stepName/:stepId.html" element={<PageAdminDataForm />} />
								<Route path=":formCode/:stepName/:stepId/:id.html" element={<PageAdminDataForm />} />
							</Route>

							{/* Trang */}
							<Route path="page.html" element={<PageAdminPage />} />
							<Route path="page/create.html" element={<PageAdminPageCreate />} />
							<Route path="page/update/:id.html" element={<PageAdminPageUpdate />} />
							<Route path="page/builder/test.html" element={<PageAdminPageBuilderTest />} />
							<Route path="page/builder/:id.html" element={<PageAdminPageBuilder />} />

							{/* Template */}
							<Route path="template.html" element={<PageAdminTemplate />} />
							<Route path="template/create.html" element={<PageAdminTemplateCreate />} />
							<Route path="template/update/:id.html" element={<PageAdminTemplateUpdate />} />

							{/* Layout */}
							<Route path="layout.html" element={<PageAdminLayout />} />
							<Route path="layout/create.html" element={<PageAdminLayoutCreate />} />
							<Route path="layout/update/:id.html" element={<PageAdminLayoutUpdate />} />

							<Route path="*" element={<NotFound />} />
						</Route>

						{publishPages.map(page => <Route path={page.url} element={<PageAdminPageBuilderView_V2 pageId={page.id} />} />)}
						{/* <Route path="/" element={<Outlet />}>
							<Route path=":url" element={<PageAdminPageBuilderView />} />
							<Route path="*" element={<PageAdminPageBuilderView />} />
						</Route> */}
					</Routes>
				</Router>
			</AppScroll>
		</Fragment>
	);
};
export default App;

const scrollPositions: Record<string, number> = {};

interface ScrollRestorationProps {
	scrollRef: React.RefObject<HTMLDivElement | null>;
}
const ScrollRestoration: FC<ScrollRestorationProps> = ({ scrollRef }) => {
	const location = useLocation();
	const navigationType = useNavigationType();

	useEffect(() => {
		if (navigationType === "POP") {
			// Back/Forward: khôi phục scroll
			const pos = scrollPositions[location.key];
			// window.scrollTo(0, pos || 0);
			scrollRef.current?.scrollTo(0, pos || 0);
		} else {
			// Push/Replace: luôn về đầu
			// window.scrollTo(0, 0);
			scrollRef.current?.scrollTo(0, 0);
		}

		return () => {
			// Lưu lại scroll position khi rời khỏi trang
			// scrollPositions[location.key] = window.scrollY;
			scrollPositions[location.key] = scrollRef.current?.scrollTop || 0;
		};
	}, [location, navigationType]);

	return null;
}